import type { IAction } from '../../action/IAction'
import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action'
import { Metadata } from '../../base'
import type { PaymentGatewayObject } from '../PaymentGatewayObject'
import type { PaymentGatewayProvider } from '../PaymentGatewayProviderEnum'

@InputType()
export class CreateAchPaymentArgs extends ActionArgs {
  @Field(() => Number)
  amount: number

  @Field(() => String)
  email: string

  @Field(() => Metadata)
  metadata: Metadata

  @Field(() => String)
  gatewayProvider?: PaymentGatewayProvider
}

export interface ICreateAchPayment extends IAction<PaymentGatewayObject, CreateAchPaymentArgs> {}
